import { createContext, FC, ReactNode, useMemo } from 'react';

export const uiKitContext = createContext<{
  locale: string;
}>({
  locale: 'nl-NL'
});

export const LocaleProvider: FC<{
  children: ReactNode;
  locale: string;
}> = ({ children, locale }) => {
  const memoizedLocale = useMemo(
    () => ({
      locale
    }),
    [locale]
  );

  return (
    <uiKitContext.Provider value={memoizedLocale}>
      {children}
    </uiKitContext.Provider>
  );
};
